import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { map, Observable, startWith, tap } from 'rxjs';
import { FileUploadService } from '../../file-upload/file-upload.service';
import { ImportDiaologTableService } from './import-dialog-table.service';

@Component({
  selector: 'dl-import-dialog-table',
  standalone: true,
  imports: [OneWebComponentsAngularModule, ReactiveFormsModule],
  templateUrl: './import-dialog-table.component.html',
  styleUrl: './import-dialog-table.component.scss'
})
export class ImportDialogTableComponent {
  public importButton = true;

  // drop down
  public frmctrlcustomerID = new FormControl('');
  public frmctrlcustomerName = new FormControl('');
  public frmctrlcustomerContactName = new FormControl('');
  public frmctrlcustomerContactEmail = new FormControl('');

  public options: string[] = [];
  public formDisabled = false;
  public constructor(private fileuploadService: FileUploadService, private importdialogTable: ImportDiaologTableService) { }

  public filteredOptionscustomerID: Observable<string[]>;
  public filteredOptionscustomerName: Observable<string[]>;
  public filteredOptionscustomerContactName: Observable<string[]>;
  public filteredOptionscustomerContactEmail: Observable<string[]>;
  public getFileData: Observable<any>;

  public ngOnInit(): void {
    this.onFileUploadData();
    
    this.frmctrlcustomerID.valueChanges.subscribe(() => this.updateImportbtn());
    this.frmctrlcustomerName.valueChanges.subscribe(() => this.updateImportbtn());
    this.frmctrlcustomerContactName.valueChanges.subscribe(() => this.updateImportbtn());
    this.frmctrlcustomerContactEmail.valueChanges.subscribe(() => this.updateImportbtn());
  }

  public onkeyDownEvent(evt: KeyboardEvent): void {
    evt.preventDefault();
  }

  public onDropdownChange(event: any): void {
    setTimeout(() => {
      this.updateImportbtn();
    }, 0);
  }

  public onFileUploadData(): void {
    this.fileuploadService.fileuploadDataobservable$.subscribe(f => {
      this.options = f.columnDetails || [];
     

      this.filteredOptionscustomerID = this.resetFilter(this.frmctrlcustomerID);
      this.filteredOptionscustomerName = this.resetFilter(this.frmctrlcustomerName);
      this.filteredOptionscustomerContactName = this.resetFilter(this.frmctrlcustomerContactName);
      this.filteredOptionscustomerContactEmail = this.resetFilter(this.frmctrlcustomerContactEmail);

      if (f.action === 'delete') {
        this.frmctrlcustomerID.setValue('');
        this.frmctrlcustomerName.setValue('');
        this.frmctrlcustomerContactName.setValue('');
        this.frmctrlcustomerContactEmail.setValue('');
        this.fileuploadService.sendIfValidData('Not Import button Active');
      } else {

        const findExactMatch = (expectedNames: string[]) =>
          this.options.find(col => 
            expectedNames.some(name => col.trim().toLowerCase() === name.toLowerCase())
          ) || '';

        this.frmctrlcustomerID.setValue(findExactMatch(['Account ID', 'Customer ID']));
        this.frmctrlcustomerName.setValue(findExactMatch(['Account name', 'Account Name', 'Customer Name']));
        this.frmctrlcustomerContactName.setValue(findExactMatch(['Account contact name', 'Account Contact Name', 'Contact Name']));
        this.frmctrlcustomerContactEmail.setValue(findExactMatch(['Account contact email', 'Account Contact Email', 'Email']));

        // Use setTimeout to ensure all values are set before validation
        setTimeout(() => {
          this.updateImportbtn();
        }, 100);
      }
    });
  }

  private resetFilter(formControlEditableDropdown: FormControl): Observable<string[]> {
    return formControlEditableDropdown.valueChanges.pipe(
      startWith(''),
      tap(() => this.updateImportbtn()),
      map(value => this._filter(value))
    );
  }

 private _filter(value: any): string[] {
    let filterValue = '';
    if (typeof value === 'string') {
      filterValue = value.toLowerCase();
    } else if (Array.isArray(value) && value.length > 0) {
      filterValue = String(value[0]).toLowerCase();
    } else if (value && typeof value === 'object') {
      filterValue = (value.value || value.label || '').toLowerCase();
    }
    
    const result = this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
    const checkResult = result && result[0]?.toLowerCase() === filterValue && result.length === 1 ? this.options : this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);

    this.updateImportbtn();
    return checkResult;
  }

  public updateImportbtn(frmctrl?: any): void {
    const columnlist = {
      Customer_ID: '',
      Customer_name: '',
      Customer_contact_name: '',
      Customer_contact_email: ''
    };
    
    const getValue = (val: any): string => {
      if (!val) return '';
      if (typeof val === 'string') return val;
      if (Array.isArray(val)) return val[0] || '';
      if (typeof val === 'object' && val.value) return val.value;
      if (typeof val === 'object' && val.label) return val.label;
      return String(val);
    };

    const customerIDVal = getValue(this.frmctrlcustomerID.value);
    const customerNameVal = getValue(this.frmctrlcustomerName.value);
    const customerContactNameVal = getValue(this.frmctrlcustomerContactName.value);
    const customerContactEmailVal = getValue(this.frmctrlcustomerContactEmail.value);
    
    const matchesOption = (val: string) =>
      !!this.options.find(option => option.trim().toLowerCase() === val.trim().toLowerCase());

    if (
      customerIDVal &&
      customerNameVal &&
      customerContactNameVal &&
      customerContactEmailVal
    ) {
      if (
        matchesOption(customerIDVal) &&
        matchesOption(customerNameVal) &&
        matchesOption(customerContactNameVal) &&
        matchesOption(customerContactEmailVal)
      ) {
        columnlist.Customer_ID = customerIDVal;
        columnlist.Customer_name = customerNameVal;
        columnlist.Customer_contact_name = customerContactNameVal;
        columnlist.Customer_contact_email = customerContactEmailVal;
        this.fileuploadService.sendIfValidData('Import button Active');
        this.importdialogTable.getMappedfileData(columnlist);
      } else {
        this.fileuploadService.sendIfValidData('Not Import button Active');
      }
    } else {
      this.fileuploadService.sendIfValidData('Not Import button Active');
    }
  }
}
